import { useEffect, useState, RefObject } from "react";

export default function useScrollStatus(containerRef: RefObject<HTMLElement>) {
  const [scrollableStatus, setScrollStatus] = useState({
    x: false,
    y: false,
    isScrolledToBottom: false,
  });

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateScrollState = () => {
      const {
        scrollWidth,
        scrollHeight,
        clientWidth,
        clientHeight,
        scrollLeft,
        scrollTop,
      } = container;

      const canScrollX =
        scrollWidth > clientWidth && scrollLeft < scrollWidth - clientWidth - 1;
      const canScrollY =
        scrollHeight > clientHeight &&
        scrollTop < scrollHeight - clientHeight - 1;

      // Check if scrolled to bottom (with small threshold for floating point precision)
      const isScrolledToBottom =
        scrollHeight > clientHeight && // Content is scrollable
        scrollTop >= scrollHeight - clientHeight - 5; // At bottom with 5px threshold

      setScrollStatus((prev) => {
        if (
          prev.x === canScrollX &&
          prev.y === canScrollY &&
          prev.isScrolledToBottom === isScrolledToBottom
        )
          return prev;
        return { x: canScrollX, y: canScrollY, isScrolledToBottom };
      });
    };

    updateScrollState();
    container.addEventListener("scroll", updateScrollState);

    return () => {
      container.removeEventListener("scroll", updateScrollState);
    };
  }, [containerRef]);

  return scrollableStatus;
}
